var app = angular.module("leonardo");

var MyWhiteLabelController = function($scope, $q, $state, $controller, FormErrorsService, WhiteLabelService,
                                      NotificationService, AuthDataService) {

  $scope.whiteLabel = WhiteLabelService.bulkObject();
  $scope.myWhiteLabel = true;

  $controller('WhiteLabelBaseController', { $scope: $scope });

  WhiteLabelService.get(AuthDataService.authData.whiteLabel.id, true).then(function (data) {
    $scope.whiteLabel = data;
    $scope.initData();
  });

  $scope.submit = function() {
    $scope.Form.$submitted = true;
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.changed = true;
    var data = $scope.getData();
    WhiteLabelService.patch($scope.whiteLabel.id, data).then(function(result) {
      NotificationService.notify('success', 'Client Instance updated!');
    });
  };
};

app.controller('MyWhiteLabelController', ['$scope', '$q', '$state', '$controller', 'FormErrorsService',
  'WhiteLabelService', 'NotificationService', 'AuthDataService', MyWhiteLabelController]);